module.exports = __webpack_public_path__ + "static/img/Fred-Rodriguez.55c11ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Fred-Rodriguez.jpg
// module id = NFZy
// module chunks = 0